import React, { useEffect, useState } from "react";
import "../../Assets/Styles/offCanvas.css";
import { useNavigate } from "react-router-dom";
import { addOrRemoveProductCart, cartSelectService, getVendorProfileDetails, sendEnquiryQuestion } from "../../Services/api";
import select_circle from "../../Assets/Images/icons/select_rectangle.png"
import unselect_circle from "../../Assets/Images/icons/unselect_rectangle.png"
import { IoMdClose } from "react-icons/io";
import { useSelector } from "react-redux";
import NodeaxiosInstance from "../../Services/nodeaxios";
import { useDispatch } from "react-redux";
import { setMembershipData } from "../../redux/slices/kitchenMembershipSlice";
import axiosInstance from "../../Services/axios";
import { showToast } from "../toastConfig/ToastConfig";


const SelectShippingOffCanvas = ({ isOpen, toggleOffCanvas, forCart, data, handelApiCall }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [shipping_type, setShiping_type] = useState('')
    const membershipData = useSelector((state) => state?.membership.membershipData)
    const [vendorStatus, setVendorstatus] = useState();

    let vendor_id = forCart?.vendor_id || forCart;

    useEffect(() => {
        getvendorStatus();
    }, []);

    const getvendorStatus = async () => {
        try {
            let reqData = {
                vendor_id: vendor_id,
            };

            let res = await getVendorProfileDetails(reqData);
            if (res?.status == 200) {
                // console.log('res.data.vendor_profile.vendor_details : ', res.data.vendor_profile.vendor_details);

                setVendorstatus(res.data.vendor_profile.vendor_details);
            };
        } catch (err) {
            if (err.response.status == 400 || err.response.status == 500) {
                showToast(err.response || "Something went wrong, please try again later", "error");
            }
        };
    }

    const addToCart = async () => {
        try {
            const reqData = {
                vendor_id: vendor_id,
                product_id: data?.product_id,
                shipping_type,
                cart_id: "",
                quantity: 1,
                operation: "add",
                card_status: "",
                card_type: "",
                card_id: "",
                addons: "",
                flow_type: "ORDER",
            };

            const res = await addOrRemoveProductCart(reqData);

            if (res?.status == 200) {
                // throw new Error("Failed to update cart");

                const cartId = res?.data?.cart_id;
                const cartItemsFromAPI = res?.data?.cart_items || [];

                localStorage.setItem("cartid", JSON.stringify(cartId));

                localStorage.setItem("productCart",
                    JSON.stringify({ shipping_type, cartId, vendorId: vendor_id, }));

                const updatedCartItems = cartItemsFromAPI.map(item => ({
                    ...item,
                    price: item?.price,
                }));
                localStorage.setItem(
                    "cart_items",
                    JSON.stringify({
                        cart_items: updatedCartItems,
                        cart_id: cartId,
                        cart_count: updatedCartItems.length,
                        sub_total: res?.data?.sub_total,
                    })
                );

                navigate(`/products/${vendor_id}`, { state: { flowtype: 'NewSearch' } })
            }
        } catch (error) {
            console.error("Add to cart failed:", error?.message || error);
        }
    };

    const selectService = async () => {
        try {
            let localServiceDetail = localStorage.getItem("serviceDetail")
                ? JSON.parse(localStorage.getItem("serviceDetail"))
                : {};

            const param = {
                vendor_id: vendor_id || forCart,
                cart_app_id: "",
                service_id: data?.service_id,
                service_type: '1',
                card_status: "",
                card_type: "",
                card_id: "",
            };

            const res = await cartSelectService(param);

            if (res?.status != 200) {
                throw new Error("Service selection failed");
            }

            const cartAppId = res?.data?.cart_app_id;
            localServiceDetail.serviceType = '1';
            localServiceDetail.vendorId = vendor_id;
            localServiceDetail.cart_app_id = cartAppId;
            localServiceDetail.cart_service = res?.data?.cart_service || [];

            localStorage.setItem("serviceDetail", JSON.stringify(localServiceDetail));

            let newService = {
                service_id: data.service_id,
                service_type: data.service_type,
                service_name: data.service_name,
                price: data.service_price
            };

            const updatedStorageData = {
                selectedService: [newService],
                general_category_id: data.general_category_id,
                service_count: 1,
                total_amount: data?.price
            };
            localStorage.setItem("serviceAdded", JSON.stringify(updatedStorageData));


            navigate(`/door-step-service/${vendor_id}`, { state: { flowtype: "NewSearch" } });

        } catch (error) {
            console.error("Error in selectService:", error);
        }
    };

    const membershipAddToCart = async () => {
        try {
            if (!membershipData) return;

            const payload = {
                vendor_id: membershipData.vendor_id,
                membership_id: membershipData.membership_id,
                shipping_type: shipping_type,
                date: membershipData.date
            };

            const res = await NodeaxiosInstance.post("kitchen/add-membership-cart", payload);

            if (res.status != 200 && res.status != 201) {
                throw new Error("Membership add to cart failed");
            }

            let productCart = {
                cartId: res.data.cartId,
            };

            localStorage.setItem("kitchen_Cart", JSON.stringify(productCart));
            dispatch(setMembershipData(payload));
            navigate(`/Review-Pay`, { state: { flowtype: 'kitchenMemberShip' } });
        } catch (error) {
            console.error("Error in membershipAddToCart:", error);
        }
    };


    function handelApiNavigate() {
        if (data?.product_id) {
            addToCart()
        } else if (data?.service_id) {
            selectService()
        } else {
            membershipAddToCart()
        }
    }

    const isMembership = (!data?.product_id && !data?.service_id) || Boolean(data?.isMembership) || Boolean(membershipData);

    const isDineinAvailable =
        !isMembership &&
        (data?.dinein_status == '1' ||
            data?.dinein_product_status == '1' ||
            vendorStatus?.dinein_product_status == '1' ||
            vendorStatus?.dinein_status == '1');

    const isInstoreAvailable =
        data?.instore_status == '1' ||
        data?.instore_product_status == '1' ||
        data?.instore_service_status == '1' ||
        data?.delivery_type == 1 ||
        data?.delivery_type == 3 ||
        data?.ticket_detail?.delivery_type == 1 ||
        data?.ticket_detail?.delivery_type == 3 ||
        vendorStatus?.instore_product_status == '1' ||
        vendorStatus?.instore_status == '1' ||
        (!data?.product_id && !data?.service_id && data?.delivery_type != 2 && data?.ticket_detail?.delivery_type != 2);

    const isDoorstepAvailable =
        data?.doorstep_status == '1' ||
        data?.product_delivery_status == '1' ||
        data?.delivery_type == 2 ||
        data?.delivery_type == 3 ||
        data?.ticket_detail?.delivery_type == 2 ||
        data?.ticket_detail?.delivery_type == 3 ||
        vendorStatus?.doorstep_status == '1' ||
        vendorStatus?.product_delivery_status == '1' ||
        (!data?.product_id && !data?.service_id && data?.delivery_type != 1 && data?.ticket_detail?.delivery_type != 1);

    return (
        <div className={`d-flex justify-content-center ${isOpen ? "modal-backdrop" : ""}`} >
            <div className={` selectShippingModal ${isOpen ? "show" : ""}`}>
                <div className="p-3">
                    <div className="d-flex justify-content-between">
                        <h5 className="ff-poppins-semiBold fs-16 text-dark ">Select Your Preferred Delivery Type</h5>
                        <p className=" ff-poppins-regular  fs-14 secondary-text-2 " onClick={() => toggleOffCanvas()}> <IoMdClose /> </p>
                    </div>
                    {isDineinAvailable && (
                        <div className={`${shipping_type == "0" ? "primary-box primary-text" : "secondary-box"} rounded-3  mb-2`}>
                            <div className="d-flex justify-content-between align-items-center p-2" onClick={() => setShiping_type("0")}>
                                <div className="d-flex align-items-center">
                                    {
                                        shipping_type == "0" ?
                                            <img src={select_circle} height="25px" width="25px" /> :
                                            <img src={unselect_circle} height="25px" width="25px" />
                                    }
                                    <div className="ms-3">
                                        <h6 className="fs-13 p-0 m-0 ff-poppins-semiBold">Dine-in</h6>
                                        <p className="fs-11 p-0 m-0 ff-poppins-regular ">Enjoy a comfortable dine-in experience at our place!</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {isInstoreAvailable && (
                        <div className={`${shipping_type == "1" ? "primary-box primary-text" : "secondary-box"} rounded-3 mb-2`}>
                            <div className="d-flex justify-content-between align-items-center p-2" onClick={() => { setShiping_type("1") }}>
                                <div className="d-flex align-items-center">
                                    {
                                        shipping_type == "1" ?
                                            <img src={select_circle} height="25px" width="25px" /> :
                                            <img src={unselect_circle} height="25px" width="25px" />
                                    }
                                    <div className="ms-3">
                                        <h6 className="fs-13 p-0 m-0 ff-poppins-semiBold">{data?.service_id ? "Instore Service" : "Instore Pickup"}</h6>
                                        <p className="fs-11 p-0 m-0 ff-poppins-regular "> {data?.service_id ? "Hassle-free in-store service available!" : "Hassle-free in-store pickup available!"}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {isDoorstepAvailable && (
                        <div className={`${shipping_type == "2" ? "primary-box primary-text" : "secondary-box"} rounded-3 mt-2 mb-2`}>
                            <div className="d-flex justify-content-between align-items-center p-2" onClick={() => setShiping_type("2")}>
                                <div className="d-flex align-items-center">
                                    {
                                        shipping_type == "2" ?
                                            <img src={select_circle} height="25px" width="25px" /> :
                                            <img src={unselect_circle} height="25px" width="25px" />
                                    }
                                    <div className="ms-3">
                                        <h6 className="fs-13 p-0 m-0 ff-poppins-semiBold">{data?.service_id ? "Doorstep Service" : "Doorstep Delivery"}</h6>
                                        <p className="fs-11 p-0 m-0 ff-poppins-regular "> {data?.service_id ? "Service charges added extra" : "Delivery charges added extra"}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="mb-2">
                        <button disabled={!shipping_type} className="primary-bottom-btn rounded-3 fs-14 ff-poppins-medium"
                            onClick={handelApiNavigate} >
                            Continue
                        </button>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectShippingOffCanvas;
